import React, { createContext, useContext, useState, useEffect } from 'react';
import { getTheme, loadThemePreference, saveThemePreference, applyThemeToDocument } from '../themes';

const ThemeContext = createContext();

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
}

export function ThemeProvider({ children }) {
  const [themePreference, setThemePreference] = useState('dark');
  const [currentTheme, setCurrentTheme] = useState(getTheme('dark'));

  // Load preference on mount
  useEffect(() => {
    const savedPreference = loadThemePreference();
    setThemePreference(savedPreference);
    updateTheme(savedPreference);
  }, []);

  // Auto mode: Re-check every hour if in auto mode
  useEffect(() => {
    if (themePreference === 'auto') {
      const interval = setInterval(() => {
        updateTheme('auto');
      }, 60 * 60 * 1000); // Check every hour

      return () => clearInterval(interval);
    }
  }, [themePreference]);

  const updateTheme = (preference) => {
    const theme = getTheme(preference);
    setCurrentTheme(theme);
    applyThemeToDocument(theme);
  };

  const setTheme = (preference) => {
    setThemePreference(preference);
    saveThemePreference(preference);
    updateTheme(preference);
    
    console.log(`🎨 Theme changed to: ${preference}`);
  };

  return (
    <ThemeContext.Provider value={{ 
      theme: currentTheme, 
      themePreference, 
      setTheme 
    }}>
      {children}
    </ThemeContext.Provider>
  );
}

